import { FILTERED_TYPES } from '../constants';
export const filterTypes = (type) => {
    return FILTERED_TYPES.includes(type);
};
//# sourceMappingURL=filterTypes.js.map